export default __webpack_public_path__ + "static/media/Group 8085.85793aea.svg";